import { jsx as _jsx } from "react/jsx-runtime";
import { str } from '../_shared/blockRender.js';
/**
 * `size-row` — ONE row of the {@link sizingChartBlock} measurements table: up to six plain text
 * cells. It is a CHILD block of `sizing-chart`, so the seller adds / removes / reorders table rows
 * in the left tree — each with a tidy cell-field inspector — instead of the old Shrine authoring
 * syntax ("one row per line, commas between columns") that violated the no-syntax-for-sellers rule.
 * The FIRST row of the parent renders as the table header band (toggleable on the parent), so the
 * placeholders show both readings (heading / value).
 *
 * The PARENT reads the cells and owns the `<tr><td>` markup (a table cell can't render itself in
 * isolation); this Component is only the registry-required standalone fallback and renders the
 * cells inline.
 */
export const sizeRowBlockSchema = {
    type: 'size-row',
    name: 'Table row',
    fields: [
        {
            id: 'c1',
            type: 'text',
            label: 'Cell 1',
            default: '',
            maxLength: 80,
            placeholder: 'Size · S',
        },
        {
            id: 'c2',
            type: 'text',
            label: 'Cell 2',
            default: '',
            maxLength: 80,
            placeholder: 'Chest · 95 cm',
        },
        {
            id: 'c3',
            type: 'text',
            label: 'Cell 3',
            default: '',
            maxLength: 80,
            placeholder: 'Length · 61 cm',
        },
        {
            id: 'c4',
            type: 'text',
            label: 'Cell 4',
            default: '',
            maxLength: 80,
            placeholder: 'Shoulders · 44 cm',
        },
        { id: 'c5', type: 'text', label: 'Cell 5', default: '', maxLength: 80 },
        { id: 'c6', type: 'text', label: 'Cell 6', default: '', maxLength: 80 },
    ],
};
/** Read a row block's cells, trimmed to the last non-empty one (so a 2-col table has 2-cell rows). */
export function sizeRowCells(settings) {
    const all = [
        str(settings?.c1),
        str(settings?.c2),
        str(settings?.c3),
        str(settings?.c4),
        str(settings?.c5),
        str(settings?.c6),
    ].map((c) => c.trim());
    let last = -1;
    all.forEach((c, i) => {
        if (c)
            last = i;
    });
    return all.slice(0, last + 1);
}
const SizeRowBlock = ({ block }) => {
    const cells = sizeRowCells(block.settings);
    if (cells.length === 0)
        return null;
    return _jsx("span", { children: cells.join(' · ') });
};
export const sizeRowBlock = {
    type: 'size-row',
    schema: sizeRowBlockSchema,
    Component: SizeRowBlock,
    meta: { label: 'Table row' },
};
//# sourceMappingURL=index.js.map